import {
  takeEvery, select, put, take,
} from 'redux-saga/effects'
import qs from 'qs'
import { LOCATION_CHANGE } from 'connected-react-router'
import {
  webStorage,
} from 'utils'
import { getI18nKebbabFormat } from 'utils/i18n'
import {
  application as applicationActions,
  viewer as viewerActions,
} from 'flux/actions'
import {
  property as propertySelectors,
  ui as uiSelectors,
} from 'flux/selectors'

import screenfull from 'screenfull'

export function* onInit() {
  const { name } = yield select(propertySelectors.selectProperty)
  document.title = name

  const language = yield select(uiSelectors.selectLanguage)
  document.documentElement.lang = getI18nKebbabFormat(language)

  yield take(viewerActions.types.INITIALIZE)
}

export function* onLocationChange({ payload: { location } }) {
  const { search } = location
  const { propertyId, language, gclid, customLabel, enableDataLayerEvents } = qs.parse(search, { ignoreQueryPrefix: true })

  if (propertyId) yield put(applicationActions.setProperty(propertyId))
  if (language) yield put(applicationActions.setLanguage(language))
  if (gclid) yield put(applicationActions.setGclid(gclid))
  if (customLabel) yield put(applicationActions.setCustomLabel(customLabel))
  if (enableDataLayerEvents) yield put(applicationActions.setEnableDataLayerEvents(enableDataLayerEvents === 'true'))
}

export function onSetProperty({ payload: { propertyId } }) {
  webStorage.setItem('propertyId', propertyId)
}

export function onSetLanguage({ payload: { language } }) {
  document.documentElement.lang = getI18nKebbabFormat(language)
  webStorage.setItem('language', language)
}

export function onToggleFullscreen({ payload: { active } }) {
  if (active) {
    screenfull.request()
  } else {
    screenfull.exit()
  }
}

export default function* () {
  yield takeEvery(applicationActions.types.INIT, onInit)
  yield takeEvery(applicationActions.types.SET_PROPERTY, onSetProperty)
  yield takeEvery(applicationActions.types.SET_LANGUAGE, onSetLanguage)
  yield takeEvery(LOCATION_CHANGE, onLocationChange)
  yield takeEvery(applicationActions.types.TOGGLE_FULLSCREEN, onToggleFullscreen)
}
